// extracted by mini-css-extract-plugin
module.exports = {"filename":"filename-module--filename--1bO7P"};